/* eslint-disable camelcase */
import { Bold, Icons, Text } from '@serodigital/ui-components';
import * as React from 'react';
import { HeatStatus } from '../../../../../shared/api-clients/gql';
import { useDetails } from '../state/detailsContext';
import { IZone } from '../state/types';
import { DetailsStatus } from '../status';

function Title({ title, zone }) {
  return (
    <div className="flex flex-col">
      <Bold>{title}</Bold>
      <Text size="small">zone {zone}</Text>
    </div>
  );
}

function Status({ isOn }) {
  return (
    <div className="flex items-end">
      <div className="flex flex-col">
        <Text>Heating status:</Text>
        <Bold className={`${isOn ? 'text-common-success' : 'text-grey-primary-text'}`}>{isOn ? 'ON' : 'OFF'}</Bold>
      </div>
    </div>
  );
}

function SetpointChanger({ onChange }) {
  return (
    <div className="flex flex-col space-y-16 w-24 fill-common-white">
      <Icons.ChevronUp
        data-qa="increase-setpoint"
        onClick={() => onChange('INC')}
        className="cursor-pointer"
        width={24}
      />
      <Icons.ChevronDown
        data-qa="decrease-setpoint"
        onClick={() => onChange('DEC')}
        className="cursor-pointer"
        width={24}
      />
    </div>
  );
}

interface IHeatingStatusProps extends IZone {
  hasNoData: boolean;
}

export function HeatingStatus({
  description,
  zone_id,
  upper_bounds,
  lower_bounds,
  hasNoData,
  setpoint,
  heating_state,
  temperature,
}: IHeatingStatusProps) {
  const { setSetpoint } = useDetails();

  function onChangeSetpoint(type: 'INC' | 'DEC') {
    if (!setpoint) return;
    const newSetpoint = type === 'INC' ? setpoint + 1 : setpoint - 1;
    if (newSetpoint > upper_bounds) return;
    if (newSetpoint < lower_bounds) return;
    setSetpoint(newSetpoint, zone_id);
  }

  const isOn = heating_state === HeatStatus.On;

  return (
    <div data-qa={'heating-status'} className="xl:w-1/2 w-full p-8">
      <DetailsStatus
        Title={<Title title={description} zone={zone_id} />}
        Status={<Status isOn={isOn} />}
        showTemp={true}
        SetpointRightColumn={<SetpointChanger onChange={onChangeSetpoint} />}
        setpoint={hasNoData ? undefined : Math.round(setpoint)}
        temperature={hasNoData ? undefined : temperature}
        upperBounds={upper_bounds}
        lowerBounds={lower_bounds}
        setpointTitle="Change temp"
      />
    </div>
  );
}
